import React from 'react';
import classnames from 'classnames';

export enum ToggleSize {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE'
}

type ToggleProps = {
  testId?: string;
  isActive: boolean;
  size?: ToggleSize;
  disabled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
};

const Toggle: React.FC<ToggleProps> = ({
  testId,
  isActive,
  disabled,
  size = ToggleSize.LARGE,
  onClick
}) => (
  <div
    data-testid={testId}
    onClick={(e) => {
      if (disabled) {
        return;
      }

      onClick?.(e);
    }}
    className={classnames(
      'flex items-center relative rounded-full border-2 bg-gray-100 transition-colors hover:ring hover:ring-blue-300',
      isActive ? 'border-primary-400' : 'border-gray-400',
      {
        'w-8 h-4': size === ToggleSize.SMALL,
        'w-10 h-6': size === ToggleSize.MEDIUM,
        'w-12 h-7': size === ToggleSize.LARGE,
        'bg-primary-400': isActive,
        'opacity-50 cursor-not-allowed': disabled
      }
    )}
  >
    <div
      className={classnames(
        'absolute rounded-full transition-all ',
        !isActive ? 'left-[4px] bg-gray-400' : 'bg-white',

        {
          'w-[10px] h-[10px]': size === ToggleSize.SMALL,
          'left-[14px]': size === ToggleSize.SMALL && isActive,
          'w-[12px] h-[12px]': size === ToggleSize.MEDIUM,
          'left-[16px]': size === ToggleSize.MEDIUM && isActive,
          'w-4 h-4': size === ToggleSize.LARGE,
          'left-[20px]': size === ToggleSize.LARGE && isActive
        }
      )}
    />
  </div>
);

export default Toggle;
